import { ENotificationsActionTypes } from '../../actions/notifications';
import { TNotificationsState } from '../../types/notifications';
import { TReduxActions } from '../../types/redux';

export const INITIAL_STATE: TNotificationsState = [];

export const notificationsReducer = (
  state: TNotificationsState = INITIAL_STATE,
  action: TReduxActions,
): TNotificationsState => {
  switch (action.type) {
    case ENotificationsActionTypes.PushNotification:
      return [...state, action.payload];

    case ENotificationsActionTypes.RemoveNotification:
      return state.filter(item => item.id !== action.payload);

    default:
      return state;
  }
};
